<template>
  <form class="nx-form nx-relation-card" :class="{ 'nx-active': active }" :data-vv-scope="scope">
    <v-progress-linear
      v-show="loading"
      indeterminate
      background-opacity="0"
      height="2"
    />

    <v-layout class="row wrap px-3">
      <v-flex class="xs12 md6">
        <nx-clipping-form-selector
          :id="`form-field-${scope}-clipping`"
          :aspect-ratios="aspectRatios"
          :additional-filters="clippingSelectorAdditionalFilters"
          :before-create-clipping-aliases="beforeCreateClippingAliases"
          :disabled="loading || disabled"
          :disable-crop="disableCrop"
          :label="$t('message.form.fields.photogalleryMainClippingId')"
          :allowNonPublished="allowNonPublished"
          :title-length="7"
          :type="types"
          :value="draft.clipping"
          :allow-only-source-aspect-ratio="allowOnlySourceAspectRatio"
          name="clipping"
          validation="required"
          @input="relationDeleted(uuid, ...$event)"
        />
      </v-flex>

      <v-flex class="xs12 md6" :class="{'pl-3': $vuetify.breakpoint.mdAndUp }">
        <component
          :is="textComponent"
          name="title"
          :id="`form-field-${scope}-title`"
          :disabled="loading || disabled"
          :label="$t('message.form.fields.title')"
          :value="draft.title"
          v-bind="textComponentProps"
        />
        <component
          :is="textComponent"
          :id="`form-field-${scope}-signatureAuthorName`"
          name="signatureAuthorName"
          :disabled="loading || disabled"
          :label="$t('message.form.fields.author')"
          :value="draft.signatureAuthorName"
          v-bind="textComponentProps"
        />
        <nx-form-text-editor
          :id="`form-field-${scope}-body`"
          class="my-0"
          name="body"
          :disabled="loading || disabled"
          :label="$t('message.form.fields.photogallery.body')"
          :value="draft.body"
          :counter="true"
        />
      </v-flex>
    </v-layout>
  </form>
</template>

<script>
import RelationImageForm from '@/modules/relation/card/form/RelationImageForm';
import NxFormTextEditor from '@/modules/form/components/FormTextEditor';
import RelationDeletionMixin from '@/modules/relation/mixins/relation-deletion.mixin';

export default {
  name: 'nx-relation-with-media-card',
  extends: RelationImageForm,
  mixins: [RelationDeletionMixin],
  components: {
    NxFormTextEditor,
  },
  props: {
    allowOnlySourceAspectRatio: {
      type: Boolean,
      default: true,
    },
  },
};
</script>
